import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// ✅ Home Pages
import Homepage from "../HomePage";
import HomePage2 from "../HomePage2/HomePage2";
import HomePage3 from "../HomePage3/HomePage3";
import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";
import SeviceSinglePage from "../SeviceSinglePage/SeviceSinglePage";
import CareerSection from "../CareerSection/CareerSection";
import CareerDetails from "../CareerDetails/CareerDetails";
import ProjectPage from "../ProjectPage/ProjectPage";
import ProjectDetails from "../ProjectDetails/ProjectDetails";
import TeamPage from "../TeamPage/TeamPage";
import ScrollToTop from "./ScrollToTop";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";
import SaasSinglePage from "../Ai-Saas-Product/SaasSinglePage";
import EcommerceSinglePage from "../Ai-Ecommerce/EcommerceSinglePage";
import ConsultingSinglePage from "../Ai-Consulting/ConsultingSinglePage";
import ChatbotSinglePage from "../Ai-Chatbot/ChatbotSinglePage";
import MarketingSinglePage from "../Ai-Marketing/MarketingSinglePage";
import MlSinglePage from "../Machinelearning/MlSinglePage";
import IntegrationSinglePage from "../Ai-integration/IntegrationSinglePage";
import DataAnalysis from "../CareerDetails/DataAnalysis";
import SoftwareEngineer from "../CareerDetails/SoftwareEngineer";
import WebDeveloper from "../CareerDetails/WebDeveloper";
import DigitalMarketing from "../CareerDetails/DigitalMarketing";
import GraphicsDesigner from "../CareerDetails/GraphicsDesigner";
import UiUxDesigner from "../CareerDetails/UiUxDesigner";
import AiIntegrationsinglepage from "../../components/BlogDetails/Ai Integration/AiIntegrationsinglepage";
import SaaSsinglepage from "../../components/BlogDetails/SaaS/SaaSsinglepage";
import Ecommercesinglepage from "../../components/BlogDetails/Ecommerce/Ecommercesinglepage";
import Marketingsinglepage from "../../components/BlogDetails/Marketing/Marketingsinglepage";
import MachineLearningsinglepage from "../../components/BlogDetails/Machine Learning/MachineLearningsinglepage";
import DataIntelsinglepage from "../../components/BlogDetails/Data Intel/DataIntelsinglepage";
import Chatbotsinglepage from "../../components/BlogDetails/Chatbot/Chatbotsinglepage";
import DataSolutionssinglepage from "../../components/BlogDetails/Data Solutions/DataSolutionssinglepage";
import Interns from "../TeamPage/Interns";
import InnovationConsultingsinglepage from "../Consulting/Innovation Consulting/InnovationConsultingsinglepage";
import DataAnalyticssinglepage from "../Consulting/Data Analytics/DataAnalyticssinglepage";
import Crmconsulting from "../Consulting/CRM Consulting/Crmconsulting";
import Crmconsultingsinglepage from "../Consulting/CRM Consulting/Crmconsultingsinglepage";

// ✅ Router Component
const AllRoute: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />
        <ScrollToTop />

        <Routes>
          {/* ✅ Home Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/ai-marketing" element={<HomePage2 />} />
          <Route path="/ai-chatbot" element={<HomePage3 />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/service" element={<ServicePage />} />
          <Route path="/data-intelligence" element={<SeviceSinglePage />} />
          <Route path="/career" element={<CareerSection />} />
          <Route path="/career-details" element={<CareerDetails />} />
          <Route path="/data-analysis" element={<DataAnalysis />} />
          <Route path="/software-engineer" element={<SoftwareEngineer />} />
          <Route path="/web-developer" element={<WebDeveloper />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/graphics-designer" element={<GraphicsDesigner />} />
          <Route path="/uiux-designer" element={<UiUxDesigner />} />
          <Route path="/project" element={<ProjectPage />} />
          <Route path="/project-details" element={<ProjectDetails />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/intern" element={<Interns />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog-details" element={<BlogDetails />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/ai-saas-product" element={<SaasSinglePage />} />
          <Route path="/ai-ecommerce" element={<EcommerceSinglePage />} />
          <Route path="/ai-chatbott" element={<ChatbotSinglePage />} />
          <Route path="/ai-markketing" element={<MarketingSinglePage />} />
          <Route path="/machine-learning" element={<MlSinglePage/>} />
          <Route path="/ai-integration" element={<IntegrationSinglePage/>} />
          <Route path="/ai-consulting" element={<ConsultingSinglePage />} />
          <Route path="/data-solutions" element={<DataSolutionssinglepage />} />
          <Route path="/saas" element={<SaaSsinglepage />} />
          <Route path="/chatbot" element={<Chatbotsinglepage />} />
          <Route path="/dataintel" element={<DataIntelsinglepage/>} />
          <Route path="/aiintegration" element={<AiIntegrationsinglepage/>} />
          <Route path="/machinelearning" element={<MachineLearningsinglepage/>} />
          <Route path="/marketing" element={<Marketingsinglepage/>} />
          <Route path="/ecommerce" element={<Ecommercesinglepage/>} />
          <Route path="/innovetionconsultancy" element={<InnovationConsultingsinglepage/>} />
          <Route path="/dataanalytics" element={<DataAnalyticssinglepage/>} />
          <Route path="/crmconsulting" element={<Crmconsultingsinglepage/>} />

          {/* ✅ Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
